// extracted by mini-css-extract-plugin
export default {"diceContainer":"DiceTool_diceContainer__vhukM","face":"DiceTool_face__-3Lxh","rolling":"DiceTool_rolling__bsS4P","dice-roll":"DiceTool_dice-roll__PMAw1"};